import {
  serializeYesplanAPIDate,
  todayDateObject
} from '../../app/libs/dateTimeUtilities';

/*  _________  */
/* |         | */
/* | EVENTS  | */
/* |_________| */

const day0 = serializeYesplanAPIDate(todayDateObject().add(-1, 'd'));
const day1 = serializeYesplanAPIDate(todayDateObject());
const day2 = serializeYesplanAPIDate(todayDateObject().add(1, 'd'));
const day3 = serializeYesplanAPIDate(todayDateObject().add(2, 'd'));
const day4 = serializeYesplanAPIDate(todayDateObject().add(3, 'd'));
const day5 = serializeYesplanAPIDate(todayDateObject().add(4, 'd'));
const day6 = serializeYesplanAPIDate(todayDateObject().add(5, 'd'));
const day7 = serializeYesplanAPIDate(todayDateObject().add(6, 'd'));

// eslint-disable-next-line import/prefer-default-export
export const testEvents = [
  {
    id: '1',
    name: 'Lunch',
    starttime: `${day1}T11:30:00+02:00`,
    endtime: `${day1}T13:30:00+02:00`,
    startdate: day1,
    enddate: day1,
    profile: {
      name: 'misc',
      id: '390-1626964157'
    },
    status: {
      name: 'Planned',
      id: '32-1626964157'
    },
    group: {
      id: '576-1649059444',
      name: 'Lunches',
      _type: 'group'
    },
    parentgroup: {
      id: '576-1649059444',
      name: 'Lunches',
      _type: 'group'
    },
    locations: [
      {
        name: 'Majolica',
        id: '202-1626964157'
      }
    ],
    defaultschedulestarttime: '11:30',
    defaultscheduleendtime: null,
    defaultschedulestart: `${day1}T11:30:00+02:00`,
    defaultscheduleend: null
  },
  {
    id: '2',
    name: 'Othello 1',
    starttime: `${day1}T09:00:00+02:00`,
    endtime: `${day1}T11:40:00+02:00`,
    startdate: day1,
    enddate: day1,
    profile: {
      name: 'project',
      id: '12-1626964156'
    },
    status: {
      name: 'Option',
      id: '30-1626964157'
    },
    parentgroup: {
      id: '482-1649059444',
      name: 'Othello',
      _type: 'group'
    },
    group: {
      id: '509-1649059444',
      name: 'Shakespeare',
      _type: 'group'
    },
    locations: [],
    defaultschedulestarttime: null,
    defaultscheduleendtime: null,
    defaultschedulestart: `${day1}T09:30:00+02:00`,
    defaultscheduleend: null
  },
  {
    id: '3',
    name: 'Hamlet 1',
    starttime: `${day1}T11:00:00+02:00`,
    endtime: `${day1}T13:50:00+02:00`,
    startdate: day1,
    enddate: day1,
    profile: {
      name: 'project',
      id: '12-1626964156'
    },
    status: {
      name: 'Option',
      id: '30-1626964157'
    },
    parentgroup: {
      id: '442-1649054342',
      name: 'Hamlet',
      _type: 'group'
    },
    group: {
      id: '509-1649059444',
      name: 'Shakespeare',
      _type: 'group'
    },
    locations: [],
    defaultschedulestarttime: null,
    defaultscheduleendtime: null,
    defaultschedulestart: `${day1}T11:00:00+02:00`,
    defaultscheduleend: null
  },
  {
    id: '4',
    name: 'Othello 2',
    starttime: `${day1}T20:00:00+02:00`,
    endtime: `${day1}T23:20:00+02:00`,
    startdate: day1,
    enddate: day1,
    profile: {
      name: 'project',
      id: '12-1626964156'
    },
    status: {
      name: 'Locked',
      id: '33-1626964157'
    },
    parentgroup: {
      id: '482-1649059444',
      name: 'Othello',
      _type: 'group'
    },
    group: {
      id: '509-1649059444',
      name: 'Shakespeare',
      _type: 'group'
    },
    locations: [
      {
        name: 'Theaterzaal',
        id: '182-1626964157'
      }
    ],
    defaultschedulestarttime: null,
    defaultscheduleendtime: null,
    defaultschedulestart: `${day1}T20:00:00+02:00`,
    defaultscheduleend: null
  },
  {
    id: '5',
    name: 'Hamlet 2',
    starttime: `${day1}T16:00:00+02:00`,
    endtime: `${day1}T20:00:00+02:00`,
    startdate: day1,
    enddate: day1,
    profile: {
      name: 'project',
      id: '12-1626964156'
    },
    status: {
      name: 'Locked',
      id: '33-1626964157'
    },
    parentgroup: {
      id: '442-1649054342',
      name: 'Hamlet',
      _type: 'group'
    },
    group: {
      id: '509-1649059444',
      name: 'Shakespeare',
      _type: 'group'
    },
    locations: [
      {
        name: 'Theaterzaal',
        id: '182-1626964157'
      }
    ],
    defaultschedulestarttime: null,
    defaultscheduleendtime: null,
    defaultschedulestart: `${day1}T16:00:00+02:00`,
    defaultscheduleend: null
  },
  {
    id: '6',
    name: 'Lunch',
    starttime: `${day2}T11:30:00+02:00`,
    endtime: `${day2}T13:30:00+02:00`,
    startdate: day2,
    enddate: day2,
    profile: {
      name: 'misc',
      id: '390-1626964157'
    },
    status: {
      name: 'Cancelled',
      id: '34-1626964157'
    },
    group: {
      id: '576-1649059444',
      name: 'Lunches',
      _type: 'group'
    },
    parentgroup: {
      id: '576-1649059444',
      name: 'Lunches',
      _type: 'group'
    },
    locations: [
      {
        name: 'Majolica',
        id: '202-1626964157'
      }
    ],
    defaultscheduledescription: 'Lunch (start)',
    defaultschedulestarttime: '11:30',
    defaultscheduleendtime: null,
    defaultschedulestart: `${day2}T11:30:00+02:00`,
    defaultscheduleend: null
  },
  {
    id: '7',
    name: 'Lunch',
    starttime: `${day3}T11:30:00+02:00`,
    endtime: `${day3}T13:30:00+02:00`,
    startdate: day3,
    enddate: day3,
    profile: {
      name: 'misc',
      id: '390-1626964157'
    },
    status: {
      name: 'Planned',
      id: '32-1626964157'
    },
    group: {
      id: '576-1649059444',
      name: 'Lunches',
      _type: 'group'
    },
    parentgroup: {
      id: '576-1649059444',
      name: 'Lunches',
      _type: 'group'
    },
    locations: [
      {
        name: 'Majolica',
        id: '202-1626964157'
      }
    ],
    defaultscheduledescription: 'Lunch (start)',
    defaultschedulestarttime: '11:30',
    defaultscheduleendtime: null,
    defaultschedulestart: `${day3}T11:30:00+02:00`,
    defaultscheduleend: null
  },
  {
    id: '8',
    name: 'Othello3',
    starttime: `${day4}T07:00:00+02:00`,
    endtime: `${day4}T07:00:00+02:00`,
    startdate: day4,
    enddate: day4,
    profile: {
      name: 'project',
      id: '12-1626964156'
    },
    status: {
      name: 'Option',
      id: '30-1626964157'
    },
    parentgroup: {
      id: '482-1649059444',
      name: 'Othello',
      _type: 'group'
    },
    group: {
      id: '509-1649059444',
      name: 'Shakespeare',
      _type: 'group'
    },
    locations: [],
    defaultschedulestarttime: null,
    defaultscheduleendtime: null,
    defaultschedulestart: `${day4}T07:00:00+02:00`,
    defaultscheduleend: null
  },
  {
    id: '9',
    name: 'Event in unnamed group',
    starttime: `${day4}T07:00:00+02:00`,
    endtime: `${day4}T07:00:00+02:00`,
    startdate: day4,
    enddate: day4,
    profile: {
      name: 'project',
      id: '12-1626964156'
    },
    status: {
      name: 'Option',
      id: '30-1626964157'
    },
    group: {
      id: '509-1649059445',
      name: '',
      _type: 'group'
    },
    parentgroup: {
      id: '509-1649059445',
      name: '',
      _type: 'group'
    },
    locations: [],
    defaultschedulestarttime: null,
    defaultscheduleendtime: null,
    defaultschedulestart: `${day4}T07:00:00+02:00`,
    defaultscheduleend: null
  }
];

export const testDataStarttime = [
  {
    id: '8',
    name: 'EventWithStartTime',
    starttime: `${day1}T20:30:00+02:00`,
    endtime: `${day1}T23:00:00+02:00`,
    startdate: day1,
    enddate: day1,
    profile: {
      name: 'ep',
      id: '388-1626964157'
    },
    status: {
      name: 'Option',
      id: '30-1626964157'
    },
    locations: [
      {
        name: 'Majolica'
      }
    ],
    defaultscheduledescription: null,
    defaultschedulestarttime: null,
    defaultscheduleendtime: null,
    defaultschedulestart: `${day1}T20:30:00+02:00`,
    defaultscheduleend: null
  },
  {
    id: '9',
    name: 'EventWithoutStartTime',
    starttime: null,
    endtime: null,
    startdate: day1,
    enddate: day1,
    profile: {
      name: 'vh',
      id: '389-1626964157'
    },
    status: {
      name: 'Planned',
      id: '32-1626964157'
    },
    locations: [
      {
        name: 'Majolica'
      }
    ],
    defaultscheduledescription: null,
    defaultschedulestarttime: null,
    defaultscheduleendtime: null,
    defaultschedulestart: null,
    defaultscheduleend: null
  },
  {
    id: '10',
    name: 'TestEventWithoutStartTime1',
    starttime: null,
    endtime: null,
    startdate: day1,
    enddate: day1,
    profile: {
      name: 'misc',
      id: '390-1626964157'
    },
    status: {
      name: 'No Status',
      id: '7-1626964156'
    },
    locations: [
      {
        name: 'Majolica',
        id: '202-1626964157'
      }
    ],
    defaultscheduledescription: null,
    defaultschedulestarttime: null,
    defaultscheduleendtime: null,
    defaultschedulestart: null,
    defaultscheduleend: null
  },
  {
    id: '11',
    name: 'TestEventWithoutStartTime2',
    starttime: null,
    endtime: null,
    startdate: day1,
    enddate: day1,
    profile: {
      name: 'misc',
      id: '390-1626964157'
    },
    status: {
      name: 'Planned',
      id: '32-1626964157'
    },
    locations: [
      {
        name: 'Domzaal'
      }
    ],
    defaultscheduledescription: null,
    defaultschedulestarttime: null,
    defaultscheduleendtime: null,
    defaultschedulestart: null,
    defaultscheduleend: null
  }
];

export const testEventsDateTimeSchedules = [
  {
    id: '1',
    name: 'Start time on same day',
    starttime: `${day1}T11:30:00+02:00`,
    endtime: `${day1}T13:30:00+02:00`,
    startdate: day1,
    enddate: day1,
    profile: {
      name: 'misc',
      id: '390-1626964157'
    },
    status: {
      name: 'Planned',
      id: '32-1626964157'
    },
    group: {
      id: '576-1649059444',
      name: 'Lunches',
      _type: 'group'
    },
    parentgroup: {
      id: '576-1649059444',
      name: 'Lunches',
      _type: 'group'
    },
    locations: [
      {
        name: 'Majolica',
        id: '202-1626964157'
      }
    ],
    defaultschedulestarttime: '11:30',
    defaultscheduleendtime: null,
    defaultschedulestart: `${day1}T11:30:00+02:00`,
    defaultscheduleend: null
  },
  {
    id: '2',
    name: 'Start and end time on same day',
    starttime: `${day1}T09:00:00+02:00`,
    endtime: `${day1}T11:40:00+02:00`,
    startdate: day1,
    enddate: day1,
    profile: {
      name: 'project',
      id: '12-1626964156'
    },
    status: {
      name: 'Option',
      id: '30-1626964157'
    },
    parentgroup: {
      id: '482-1649059444',
      name: 'Othello',
      _type: 'group'
    },
    group: {
      id: '509-1649059444',
      name: 'Shakespeare',
      _type: 'group'
    },
    locations: [],
    defaultschedulestarttime: `09:30`,
    defaultscheduleendtime: `11:40`,
    defaultschedulestart: `${day1}T09:30:00+02:00`,
    defaultscheduleend: `${day1}T11:40:00+02:00`
  },
  {
    id: '3',
    name: 'End on next day',
    starttime: `${day1}T11:00:00+02:00`,
    endtime: `${day2}T13:50:00+02:00`,
    startdate: day1,
    enddate: day2,
    profile: {
      name: 'project',
      id: '12-1626964156'
    },
    status: {
      name: 'Option',
      id: '30-1626964157'
    },
    parentgroup: {
      id: '442-1649054342',
      name: 'Hamlet',
      _type: 'group'
    },
    group: {
      id: '509-1649059444',
      name: 'Shakespeare',
      _type: 'group'
    },
    locations: [],
    defaultschedulestarttime: '11:00',
    defaultscheduleendtime: '13:50',
    defaultschedulestart: `${day1}T11:00:00+02:00`,
    defaultscheduleend: `${day2}T13:50:00+02:00`
  },
  {
    id: '4',
    name: 'Start and end on next day',
    starttime: `${day2}T11:00:00+02:00`,
    endtime: `${day2}T13:50:00+02:00`,
    startdate: day1,
    enddate: day2,
    profile: {
      name: 'project',
      id: '12-1626964156'
    },
    status: {
      name: 'Option',
      id: '30-1626964157'
    },
    parentgroup: {
      id: '442-1649054342',
      name: 'Hamlet',
      _type: 'group'
    },
    group: {
      id: '509-1649059444',
      name: 'Shakespeare',
      _type: 'group'
    },
    locations: [],
    defaultschedulestarttime: '11:00',
    defaultscheduleendtime: '13:50',
    defaultschedulestart: `${day2}T11:00:00+02:00`,
    defaultscheduleend: `${day2}T13:50:00+02:00`
  },
  {
    id: '5',
    name: 'Start on previous day and end on this day less than 24h apart',
    starttime: `${day0}T22:00:00+02:00`,
    endtime: `${day1}T11:50:00+02:00`,
    startdate: day1,
    enddate: day1,
    profile: {
      name: 'project',
      id: '12-1626964156'
    },
    status: {
      name: 'Option',
      id: '30-1626964157'
    },
    parentgroup: {
      id: '442-1649054342',
      name: 'Hamlet',
      _type: 'group'
    },
    group: {
      id: '509-1649059444',
      name: 'Shakespeare',
      _type: 'group'
    },
    locations: [],
    defaultschedulestarttime: '22:00',
    defaultscheduleendtime: '11:50',
    defaultschedulestart: `${day0}T22:00:00+02:00`,
    defaultscheduleend: `${day1}T11:50:00+02:00`
  },
  {
    id: '6',
    name: 'Start on previous day and end on this day more than 24h apart',
    starttime: `${day0}T11:00:00+02:00`,
    endtime: `${day1}T13:50:00+02:00`,
    startdate: day1,
    enddate: day1,
    profile: {
      name: 'project',
      id: '12-1626964156'
    },
    status: {
      name: 'Option',
      id: '30-1626964157'
    },
    parentgroup: {
      id: '442-1649054342',
      name: 'Hamlet',
      _type: 'group'
    },
    group: {
      id: '509-1649059444',
      name: 'Shakespeare',
      _type: 'group'
    },
    locations: [],
    defaultschedulestarttime: '11:00',
    defaultscheduleendtime: '13:50',
    defaultschedulestart: `${day0}T11:00:00+02:00`,
    defaultscheduleend: `${day1}T13:50:00+02:00`
  },
  {
    id: '7',
    name: 'Start on previous day and end on next day',
    starttime: `${day0}T11:00:00+02:00`,
    endtime: `${day2}T13:50:00+02:00`,
    startdate: day1,
    enddate: day2,
    profile: {
      name: 'project',
      id: '12-1626964156'
    },
    status: {
      name: 'Option',
      id: '30-1626964157'
    },
    parentgroup: {
      id: '442-1649054342',
      name: 'Hamlet',
      _type: 'group'
    },
    group: {
      id: '509-1649059444',
      name: 'Shakespeare',
      _type: 'group'
    },
    locations: [],
    defaultschedulestarttime: '11:00',
    defaultscheduleendtime: '13:50',
    defaultschedulestart: `${day0}T11:00:00+02:00`,
    defaultscheduleend: `${day2}T13:50:00+02:00`
  }
];

export const testEventsAnnouncedStarttime = [
  {
    id: '1',
    name: 'Test Event',
    starttime: `${day1}T09:00:00+02:00`,
    endtime: `${day1}T12:30:00+02:00`,
    startdate: day1,
    enddate: day1,
    profile: {
      name: 'misc',
      id: '390-1626964157'
    },
    status: {
      name: 'Planned',
      id: '32-1626964157'
    },
    locations: [
      {
        name: 'Majolica',
        id: '202-1626964157'
      }
    ],
    defaultschedulestarttime: `09:00`,
    defaultscheduleendtime: null,
    defaultschedulestart: `${day1}T09:00:00+02:00`,
    defaultscheduleend: null
  },
  {
    id: '2',
    name: 'Test Event Starting at 9 with Announced starttime later',
    starttime: `${day1}T09:00:00+02:00`,
    endtime: `${day1}T12:40:00+02:00`,
    startdate: day1,
    enddate: day1,
    profile: {
      name: 'project',
      id: '12-1626964156'
    },
    status: {
      name: 'Option',
      id: '30-1626964157'
    },
    locations: [],
    defaultschedulestarttime: `09:30`,
    defaultscheduleendtime: `12:40`,
    defaultschedulestart: `${day1}T09:30:00+02:00`,
    defaultscheduleend: `${day1}T12:40:00+02:00`
  },
  {
    id: '3',
    name: 'Another Test Event Starting at 9',
    starttime: `${day1}T09:00:00+02:00`,
    endtime: `${day1}T13:50:00+02:00`,
    startdate: day1,
    enddate: day1,
    profile: {
      name: 'project',
      id: '12-1626964156'
    },
    status: {
      name: 'Option',
      id: '30-1626964157'
    },
    locations: [],
    defaultschedulestarttime: `09:00`,
    defaultscheduleendtime: null,
    defaultschedulestart: `${day1}T09:00:00+02:00`,
    defaultscheduleend: null
  }
];

export const findTestEventsWithStartDate = (events, dateObject) => {
  const start = serializeYesplanAPIDate(dateObject);
  return events.filter((e) => e.startdate === start);
};

export const createEventsInBulk = (nbr, dateObject) => {
  const events = [];
  for (let i = 1; i <= nbr; i++) {
    events.push({
      id: `${i}`,
      name: `Event-${i}`,
      starttime: `${serializeYesplanAPIDate(dateObject)}T20:30:00+02:00`,
      endtime: `${serializeYesplanAPIDate(dateObject)}T23:00:00+02:00`,
      startdate: serializeYesplanAPIDate(dateObject),
      enddate: serializeYesplanAPIDate(dateObject),
      profile: {
        name: 'misc',
        id: '390-1626964157'
      },
      status: {
        name: 'No Status',
        id: '7-1626964156'
      },
      locations: [
        {
          name: 'Majolica'
        }
      ],
      defaultscheduledescription: null,
      defaultschedulestarttime: null,
      defaultscheduleendtime: null,
      defaultschedulestart: `${serializeYesplanAPIDate(dateObject)}T20:30:00+02:00`,
      defaultscheduleend: null
    });
  }
  return events;
};

export const createEventsWithGroupsInBulk = (
  nbrOfTopMostGroups,
  nbrOfDirectGroups,
  nbrOfEventsPerGroup,
  dateObject
) => {
  let events = [];
  for (let nbrForTopMost = 0; nbrForTopMost <= nbrOfTopMostGroups; nbrForTopMost++) {
    const tmg = {
      name: `topmostgroup${nbrForTopMost}`,
      id: `tmg${nbrForTopMost}`,
      group: null,
      parentgroup: null,
      _type: 'group'
    };
    for (let nbrOfDirect = 0; nbrOfDirect <= nbrOfDirectGroups; nbrOfDirect++) {
      const dg = {
        name: `tmg${nbrForTopMost}directgroup${nbrOfDirect}`,
        id: `tmg${nbrForTopMost}dg${nbrOfDirect}`,
        group: tmg,
        parentgroup: tmg,
        _type: 'group'
      };
      const eventsOnDate = createEventsInBulk(nbrOfEventsPerGroup, dateObject).map(
        (event) => ({ ...event, group: tmg, parentgroup: dg })
      );
      events = [...events, ...eventsOnDate];
    }
  }
  return events;
};

export const createEventOrderedByEventGroupInBulk = (nbr, dateObject) => {
  const events = [];
  for (let i = 1; i <= nbr; i++) {
    events.push({
      id: `${i}`,
      name: `Event-${i}`,
      starttime: `${serializeYesplanAPIDate(dateObject)}T20:30:00+02:00`,
      endtime: `${serializeYesplanAPIDate(dateObject)}T23:00:00+02:00`,
      startdate: serializeYesplanAPIDate(dateObject),
      enddate: serializeYesplanAPIDate(dateObject),
      profile: {
        name: 'misc',
        id: '390-1626964157'
      },
      status: {
        name: 'No Status',
        id: '7-1626964156'
      },
      locations: [
        {
          name: 'Majolica'
        }
      ],
      group: { name: 'Shakespeare', id: '509-1649059444' },
      parentgroup: { name: 'Othello', id: '482-1649059444' },
      defaultscheduledescription: null,
      defaultschedulestarttime: null,
      defaultscheduleendtime: null,
      defaultschedulestart: `${serializeYesplanAPIDate(dateObject)}T20:30:00+02:00`,
      defaultscheduleend: null
    });
  }
  return events;
};

export const createEventsCrossingDaylineOnDate = (dateObject) => {
  const day1String = serializeYesplanAPIDate(dateObject);
  const day0String = serializeYesplanAPIDate(dateObject.clone().add(-1, 'd'));
  const day2String = serializeYesplanAPIDate(dateObject.clone().add(1, 'd'));
  return [
    {
      id: '1',
      name: 'Lunch',
      starttime: `${day1String}T11:30:00+02:00`,
      endtime: `${day1String}T13:30:00+02:00`,
      startdate: day1String,
      enddate: day1String,
      profile: {
        name: 'misc',
        id: '390-1626964157'
      },
      status: {
        name: 'Planned',
        id: '32-1626964157'
      },
      group: {
        id: '576-1649059444',
        name: 'Lunches',
        _type: 'group'
      },
      parentgroup: {
        id: '576-1649059444',
        name: 'Lunches',
        _type: 'group'
      },
      locations: [
        {
          name: 'Majolica'
        }
      ],
      defaultschedulestarttime: '11:30',
      defaultscheduleendtime: null,
      defaultschedulestart: `${day1String}T11:30:00+02:00`,
      defaultscheduleend: null
    },
    {
      id: '2',
      name: 'Othello 2',
      starttime: `${day1String}T15:00:00+02:00`,
      endtime: `${day2String}T23:00:00+02:00`,
      startdate: day1String,
      enddate: day2String,
      profile: {
        name: 'project',
        id: '12-1626964156'
      },
      status: {
        name: 'No Status',
        id: '7-1626964156'
      },
      parentgroup: {
        id: '482-1649059444',
        name: 'Othello',
        _type: 'group'
      },
      group: {
        id: '509-1649059444',
        name: 'Shakespeare',
        _type: 'group'
      },
      locations: [
        {
          name: 'Theaterzaal',
          id: '182-1626964157'
        }
      ],
      defaultschedulestarttime: '15:00',
      defaultscheduleendtime: '23:00',
      defaultschedulestart: `${day1String}T15:00:00+02:00`,
      defaultscheduleend: `${day2String}T23:00:00+02:00`
    },
    {
      id: '3',
      name: 'Othello 1',
      starttime: `${day0String}T15:00:00+02:00`,
      endtime: `${day2String}T23:00:00+02:00`,
      startdate: day1String,
      enddate: day2String,
      profile: {
        name: 'project',
        id: '12-1626964156'
      },
      status: {
        name: 'Planned',
        id: '32-1626964157'
      },
      parentgroup: {
        id: '482-1649059444',
        name: 'Othello',
        _type: 'group'
      },
      group: {
        id: '509-1649059444',
        name: 'Shakespeare',
        _type: 'group'
      },
      locations: [
        {
          name: 'Theaterzaal',
          id: '182-1626964157'
        }
      ],
      defaultschedulestarttime: '15:00',
      defaultscheduleendtime: '23:00',
      defaultschedulestart: `${day0String}T15:00:00+02:00`,
      defaultscheduleend: `${day2String}T23:00:00+02:00`
    }
  ];
};

export const testEventsCrossingDayline = createEventsCrossingDaylineOnDate(
  todayDateObject()
);

export const weekEventsDay1 = [
  {
    id: '1',
    name: 'Lunch',
    starttime: `2021-08-23T11:30:00+02:00`,
    endtime: `2021-08-23T13:30:00+02:00`,
    startdate: '2021-08-23',
    enddate: '2021-08-23',
    profile: {
      name: 'misc',
      id: '390-1626964157'
    },
    status: {
      name: 'Confirmed Option',
      id: '31-1626964157'
    },
    group: {
      id: '576-1649059444',
      name: 'Lunches'
    },
    parentgroup: {
      id: '576-1649059444',
      name: 'Lunches'
    },
    locations: [
      {
        name: 'Majolica',
        id: '202-1626964157'
      }
    ],
    defaultschedulestarttime: '11:30',
    defaultscheduleendtime: null,
    defaultschedulestart: `2021-08-23T11:30:00+02:00`,
    defaultscheduleend: null
  },
  {
    id: '2',
    name: 'Othello 1',
    starttime: `2021-08-23T15:00:00+02:00`,
    endtime: `2021-08-23T23:00:00+02:00`,
    startdate: '2021-08-23',
    enddate: '2021-08-23',
    profile: {
      name: 'project',
      id: '12-1626964156'
    },
    status: {
      name: 'Invoiced',
      id: '35-1626964157'
    },
    parentgroup: {
      id: '482-1649059444',
      name: 'Othello'
    },
    group: {
      id: '509-1649059444',
      name: 'Shakespeare'
    },
    locations: [
      {
        name: 'Theaterzaal',
        id: '182-1626964157'
      }
    ],
    defaultschedulestarttime: null,
    defaultscheduleendtime: null,
    defaultschedulestart: `2021-08-23T15:00:00+02:00`,
    defaultscheduleend: null
  }
];

export const weekEventsDay2 = [
  {
    id: '3',
    name: 'Lunch',
    starttime: `2021-08-24T11:30:00+02:00`,
    endtime: `2021-08-24T13:30:00+02:00`,
    startdate: '2021-08-24',
    enddate: '2021-08-24',
    profile: {
      name: 'misc',
      id: '390-1626964157'
    },
    status: {
      name: 'Cancelled',
      id: '34-1626964157'
    },
    group: {
      id: '576-1649059444',
      name: 'Lunches'
    },
    parentgroup: {
      id: '576-1649059444',
      name: 'Lunches'
    },
    locations: [
      {
        name: 'Majolica',
        id: '202-1626964157'
      }
    ],
    defaultschedulestarttime: '11:30',
    defaultscheduleendtime: null,
    defaultschedulestart: `2021-08-24T11:30:00+02:00`,
    defaultscheduleend: null
  }
];

export const weekEventsDay3 = [
  {
    id: '4',
    name: 'Lunch',
    starttime: `2021-08-25T11:30:00+02:00`,
    endtime: `2021-08-25T13:30:00+02:00`,
    startdate: '2021-08-25',
    enddate: '2021-08-25',
    profile: {
      name: 'misc',
      id: '390-1626964157'
    },
    status: {
      name: 'Planned',
      id: '32-1626964157'
    },
    group: {
      id: '576-1649059444',
      name: 'Lunches'
    },
    parentgroup: {
      id: '576-1649059444',
      name: 'Lunches'
    },
    locations: [
      {
        name: 'Majolica',
        id: '202-1626964157'
      }
    ],
    defaultschedulestarttime: '11:30',
    defaultscheduleendtime: null,
    defaultschedulestart: `2021-08-25T11:30:00+02:00`,
    defaultscheduleend: null
  },
  {
    id: '5',
    name: 'Othello 2',
    starttime: `2021-08-25T15:00:00+02:00`,
    endtime: `2021-08-25T23:00:00+02:00`,
    startdate: '2021-08-25',
    enddate: '2021-08-25',
    profile: {
      name: 'project',
      id: '12-1626964156'
    },
    status: {
      name: 'Cancelled',
      id: '34-1626964157'
    },
    parentgroup: {
      id: '482-1649059444',
      name: 'Othello'
    },
    group: {
      id: '509-1649059444',
      name: 'Shakespeare'
    },
    locations: [
      {
        name: 'Theaterzaal',
        id: '182-1626964157'
      }
    ],
    defaultschedulestarttime: null,
    defaultscheduleendtime: null,
    defaultschedulestart: `2021-08-25T15:00:00+02:00`,
    defaultscheduleend: null
  }
];

export const weekEventsDay4 = [
  {
    id: '6',
    name: 'Othello 3',
    starttime: `2021-08-26T15:00:00+02:00`,
    endtime: `2021-08-23T23:00:00+02:00`,
    startdate: '2021-08-26',
    enddate: '2021-08-26',
    profile: {
      name: 'project',
      id: '12-1626964156'
    },
    status: {
      name: 'Planned',
      id: '32-1626964157'
    },
    parentgroup: {
      id: '482-1649059444',
      name: 'Othello'
    },
    group: {
      id: '509-1649059444',
      name: 'Shakespeare'
    },
    locations: [
      {
        name: 'Theaterzaal',
        id: '182-1626964157'
      }
    ],
    defaultschedulestarttime: null,
    defaultscheduleendtime: null,
    defaultschedulestart: `2021-08-26T15:00:00+02:00`,
    defaultscheduleend: null
  }
];

export const weekEventsDay5 = [
  {
    id: '7',
    name: 'Lunch',
    starttime: `2021-08-27T11:30:00+02:00`,
    endtime: `2021-08-27T13:30:00+02:00`,
    startdate: '2021-08-27',
    enddate: '2021-08-27',
    profile: {
      name: 'misc',
      id: '390-1626964157'
    },
    status: {
      name: 'Option',
      id: '30-1626964157'
    },
    group: {
      id: '576-1649059444',
      name: 'Lunches'
    },
    parentgroup: {
      id: '576-1649059444',
      name: 'Lunches'
    },
    locations: [
      {
        name: 'Majolica',
        id: '202-1626964157'
      }
    ],
    defaultschedulestarttime: '11:30',
    defaultscheduleendtime: null,
    defaultschedulestart: `2021-08-27T11:30:00+02:00`,
    defaultscheduleend: null
  },
  {
    id: '8',
    name: 'Othello 4',
    starttime: `2021-08-27T15:00:00+02:00`,
    endtime: `2021-08-27T23:00:00+02:00`,
    startdate: '2021-08-27',
    enddate: '2021-08-27',
    profile: {
      name: 'project',
      id: '12-1626964156'
    },
    status: {
      name: 'Planned',
      id: '32-1626964157'
    },
    parentgroup: {
      id: '482-1649059444',
      name: 'Othello'
    },
    group: {
      id: '509-1649059444',
      name: 'Shakespeare'
    },
    locations: [
      {
        name: 'Theaterzaal',
        id: '182-1626964157'
      }
    ],
    defaultschedulestarttime: null,
    defaultscheduleendtime: null,
    defaultschedulestart: `2021-08-27T15:00:00+02:00`,
    defaultscheduleend: null
  }
];

export const weekEventsDay6 = [];

export const weekEventsDay7 = [
  {
    id: '9',
    name: 'Lunch',
    starttime: `2021-08-29T11:30:00+02:00`,
    endtime: `2021-08-29T13:30:00+02:00`,
    startdate: '2021-08-29',
    enddate: '2021-08-29',
    profile: {
      name: 'misc',
      id: '390-1626964157'
    },
    status: {
      name: 'Option',
      id: '30-1626964157'
    },
    group: {
      id: '576-1649059444',
      name: 'Lunches'
    },
    parentgroup: {
      id: '576-1649059444',
      name: 'Lunches'
    },
    locations: [
      {
        name: 'Majolica',
        id: '202-1626964157'
      }
    ],
    defaultschedulestarttime: '11:30',
    defaultscheduleendtime: null,
    defaultschedulestart: `2021-08-29T11:30:00+02:00`,
    defaultscheduleend: null
  }
];

export const eventUngrouped = {
  id: '1',
  name: 'Ungrouped event',
  starttime: `2021-08-23T11:30:00+02:00`,
  endtime: `2021-08-23T13:30:00+02:00`,
  startdate: '2021-08-23',
  enddate: '2021-08-23',
  profile: {
    name: 'misc',
    id: '390-1626964157'
  },
  status: {
    name: 'Option',
    id: '30-1626964157'
  },
  group: undefined,
  locations: [
    {
      name: 'Majolica',
      id: '202-1626964157'
    }
  ],
  defaultschedulestarttime: '11:30',
  defaultscheduleendtime: null,
  defaultschedulestart: `2021-08-23T11:30:00+02:00`,
  defaultscheduleend: null
};

export const eventWithOnlyTopGroup = {
  id: '2',
  name: 'Lunch',
  starttime: `2021-08-23T11:30:00+02:00`,
  endtime: `2021-08-23T13:30:00+02:00`,
  startdate: '2021-08-23',
  enddate: '2021-08-23',
  profile: {
    name: 'misc',
    id: '390-1626964157'
  },
  status: {
    name: 'Option',
    id: '30-1626964157'
  },
  group: {
    id: '576-1649059444',
    name: 'Lunches'
  },
  parentgroup: {
    id: '576-1649059444',
    name: 'Lunches'
  },
  locations: [
    {
      name: 'Majolica',
      id: '202-1626964157'
    }
  ],
  defaultschedulestarttime: '11:30',
  defaultscheduleendtime: null,
  defaultschedulestart: `2021-08-23T11:30:00+02:00`,
  defaultscheduleend: null
};

export const eventWithTopAndDirectGroup = {
  id: '3',
  name: 'Othello 1',
  starttime: `2021-08-23T15:00:00+02:00`,
  endtime: `2021-08-23T23:00:00+02:00`,
  startdate: '2021-08-23',
  enddate: '2021-08-23',
  profile: {
    name: 'project',
    id: '12-1626964156'
  },
  status: {
    name: 'Invoiced',
    id: '35-1626964157'
  },
  parentgroup: {
    id: '482-1649059444',
    name: 'Othello'
  },
  group: {
    id: '509-1649059444',
    name: 'Shakespeare'
  },
  locations: [
    {
      name: 'Theaterzaal',
      id: '182-1626964157'
    }
  ],
  defaultschedulestarttime: null,
  defaultscheduleendtime: null,
  defaultschedulestart: `2021-08-23T15:00:00+02:00`,
  defaultscheduleend: null
};

export const shakespeareTopGroupData = { name: 'Shakespeare', id: '509-1649059444' };
export const shakespeareOthelloGroupData = {
  id: '482-1649059444',
  name: 'Othello'
};
const shakespeareHamletGroupData = {
  id: '442-1649054342',
  name: 'Hamlet',
  _type: 'group'
};

export const shakespeareNoSubgroupEvent = {
  id: '4',
  name: 'The taming of the Shrew',
  starttime: `2021-08-23T15:00:00+02:00`,
  endtime: `2021-08-23T23:00:00+02:00`,
  startdate: '2021-08-23',
  enddate: '2021-08-23',
  profile: {
    name: 'project',
    id: '12-1626964156'
  },
  status: {
    name: 'Invoiced',
    id: '35-1626964157'
  },
  parentgroup: shakespeareTopGroupData,
  group: shakespeareTopGroupData,
  locations: [
    {
      name: 'Theaterzaal',
      id: '182-1626964157'
    }
  ],
  defaultschedulestarttime: null,
  defaultscheduleendtime: null,
  defaultschedulestart: `2021-08-23T15:00:00+02:00`,
  defaultscheduleend: null
};
export const shakespeareSubgroupOthelloEvent = {
  id: '5',
  name: 'Othello 1',
  starttime: `2021-08-23T15:00:00+02:00`,
  endtime: `2021-08-23T23:00:00+02:00`,
  startdate: '2021-08-23',
  enddate: '2021-08-23',
  profile: {
    name: 'project',
    id: '12-1626964156'
  },
  status: {
    name: 'Invoiced',
    id: '35-1626964157'
  },
  parentgroup: shakespeareOthelloGroupData,
  group: shakespeareTopGroupData,
  locations: [
    {
      name: 'Theaterzaal',
      id: '182-1626964157'
    }
  ],
  defaultschedulestarttime: null,
  defaultscheduleendtime: null,
  defaultschedulestart: `2021-08-23T15:00:00+02:00`,
  defaultscheduleend: null
};

export const shakespeareSubgroupHamletEvent = {
  id: '6',
  name: 'Hamlet 1',
  starttime: `2021-08-23T15:00:00+02:00`,
  endtime: `2021-08-23T23:00:00+02:00`,
  startdate: '2021-08-23',
  enddate: '2021-08-23',
  profile: {
    name: 'project',
    id: '12-1626964156'
  },
  status: {
    name: 'Option',
    id: '30-1626964157'
  },
  parentgroup: shakespeareHamletGroupData,
  group: shakespeareTopGroupData,
  locations: [],
  defaultschedulestarttime: '11:00',
  defaultscheduleendtime: null,
  defaultschedulestart: `2021-08-23T11:00:00+02:00`,
  defaultscheduleend: null
};

export const groupWithEventWithTopAndDirectGroup = [
  shakespeareSubgroupOthelloEvent,
  { ...shakespeareSubgroupOthelloEvent, id: '7' },
  shakespeareNoSubgroupEvent,
  shakespeareSubgroupHamletEvent,
  { ...shakespeareSubgroupHamletEvent, id: '8' }
];
const unnamedTopGroupData = { name: '', id: '509-1649059445' };

export const eventInsideUnnamedGroup = [
  {
    id: '2',
    name: 'Lunch',
    starttime: `2021-08-23T11:30:00+02:00`,
    endtime: `2021-08-23T13:30:00+02:00`,
    startdate: '2021-08-23',
    enddate: '2021-08-23',
    profile: {
      name: 'misc',
      id: '390-1626964157'
    },
    status: {
      name: 'Option',
      id: '30-1626964157'
    },
    group: unnamedTopGroupData,
    parentgroup: unnamedTopGroupData,
    locations: [
      {
        name: 'Majolica',
        id: '202-1626964157'
      }
    ],
    defaultschedulestarttime: '11:30',
    defaultscheduleendtime: null,
    defaultschedulestart: `2021-08-23T11:30:00+02:00`,
    defaultscheduleend: null
  }
];
const longNamedTopGroupData = {
  name: 'Events group with a long title that should be truncated',
  id: '509-1649059446'
};

export const eventInsideLongNamedGroup = [
  {
    id: '2',
    name: 'Event inside long named event group',
    starttime: `2021-08-23T11:30:00+02:00`,
    endtime: `2021-08-23T13:30:00+02:00`,
    startdate: '2021-08-23',
    enddate: '2021-08-23',
    profile: {
      name: 'misc',
      id: '390-1626964157'
    },
    status: {
      name: 'Option',
      id: '30-1626964157'
    },
    group: longNamedTopGroupData,
    parentgroup: longNamedTopGroupData,
    locations: [
      {
        name: 'Majolica',
        id: '202-1626964157'
      }
    ],
    defaultschedulestarttime: '11:30',
    defaultscheduleendtime: null,
    defaultschedulestart: `2021-08-23T11:30:00+02:00`,
    defaultscheduleend: null
  }
];
export const weekEventsDayOrderedByEventGroup1 = [
  {
    id: '1',
    name: 'Lunch',
    starttime: `2021-08-23T11:30:00+02:00`,
    endtime: `2021-08-23T13:30:00+02:00`,
    startdate: '2021-08-23',
    enddate: '2021-08-23',
    profile: {
      name: 'misc',
      id: '390-1626964157'
    },
    status: {
      name: 'Confirmed Option',
      id: '31-1626964157'
    },
    group: {
      id: '576-1649059444',
      name: 'Lunches'
    },
    parentgroup: {
      id: '576-1649059444',
      name: 'Lunches'
    },
    locations: [
      {
        name: 'Majolica',
        id: '202-1626964157'
      }
    ],
    defaultschedulestarttime: '11:30',
    defaultscheduleendtime: null,
    defaultschedulestart: `2021-08-23T11:30:00+02:00`,
    defaultscheduleend: null
  },
  {
    id: '2',
    name: 'Othello 1',
    starttime: `2021-08-23T15:00:00+02:00`,
    endtime: `2021-08-23T23:00:00+02:00`,
    startdate: '2021-08-23',
    enddate: '2021-08-23',
    profile: {
      name: 'project',
      id: '12-1626964156'
    },
    status: {
      name: 'Invoiced',
      id: '35-1626964157'
    },
    parentgroup: {
      id: '482-1649059444',
      name: 'Othello'
    },
    group: {
      id: '509-1649059444',
      name: 'Shakespeare'
    },
    locations: [
      {
        name: 'Theaterzaal',
        id: '182-1626964157'
      }
    ],
    defaultschedulestarttime: null,
    defaultscheduleendtime: null,
    defaultschedulestart: `2021-08-23T15:00:00+02:00`,
    defaultscheduleend: null
  }
];

export const weekEventsDayOrderedByEventGroup2 = [
  {
    id: '3',
    name: 'Lunch',
    starttime: `2021-08-24T11:30:00+02:00`,
    endtime: `2021-08-24T13:30:00+02:00`,
    startdate: '2021-08-24',
    enddate: '2021-08-24',
    profile: {
      name: 'misc',
      id: '390-1626964157'
    },
    status: {
      name: 'Cancelled',
      id: '34-1626964157'
    },
    group: {
      id: '576-1649059444',
      name: 'Lunches'
    },
    locations: [
      {
        name: 'Majolica',
        id: '202-1626964157'
      }
    ],
    defaultschedulestarttime: '11:30',
    defaultscheduleendtime: null,
    defaultschedulestart: `2021-08-24T11:30:00+02:00`,
    defaultscheduleend: null
  }
];

export const weekEventsDayOrderedByEventGroup3 = [
  {
    id: '4',
    name: 'Lunch',
    starttime: `2021-08-25T11:30:00+02:00`,
    endtime: `2021-08-25T13:30:00+02:00`,
    startdate: '2021-08-25',
    enddate: '2021-08-25',
    profile: {
      name: 'misc',
      id: '390-1626964157'
    },
    status: {
      name: 'Planned',
      id: '32-1626964157'
    },
    group: {
      id: '576-1649059444',
      name: 'Lunches'
    },
    locations: [
      {
        name: 'Majolica',
        id: '202-1626964157'
      }
    ],
    defaultschedulestarttime: '11:30',
    defaultscheduleendtime: null,
    defaultschedulestart: `2021-08-25T11:30:00+02:00`,
    defaultscheduleend: null
  },

  {
    id: '5',
    name: 'Othello 2',
    starttime: `2021-08-25T15:00:00+02:00`,
    endtime: `2021-08-25T23:00:00+02:00`,
    startdate: '2021-08-25',
    enddate: '2021-08-25',
    profile: {
      name: 'project',
      id: '12-1626964156'
    },
    status: {
      name: 'Cancelled',
      id: '34-1626964157'
    },
    parentgroup: {
      id: '482-1649059444',
      name: 'Othello'
    },
    group: {
      id: '509-1649059444',
      name: 'Shakespeare'
    },
    locations: [
      {
        name: 'Theaterzaal',
        id: '182-1626964157'
      }
    ],
    defaultschedulestarttime: null,
    defaultscheduleendtime: null,
    defaultschedulestart: `2021-08-25T15:00:00+02:00`,
    defaultscheduleend: null
  }
];

export const weekEventsDayOrderedByEventGroup4 = [
  {
    id: '6',
    name: 'Othello 3',
    starttime: `2021-08-26T15:00:00+02:00`,
    endtime: `2021-08-23T23:00:00+02:00`,
    startdate: '2021-08-26',
    enddate: '2021-08-26',
    profile: {
      name: 'project',
      id: '12-1626964156'
    },
    status: {
      name: 'Planned',
      id: '32-1626964157'
    },
    parentgroup: {
      id: '482-1649059444',
      name: 'Othello'
    },
    group: {
      id: '509-1649059444',
      name: 'Shakespeare'
    },
    locations: [
      {
        name: 'Theaterzaal',
        id: '182-1626964157'
      }
    ],
    defaultschedulestarttime: null,
    defaultscheduleendtime: null,
    defaultschedulestart: `2021-08-26T15:00:00+02:00`,
    defaultscheduleend: null
  },
  {
    id: '7',
    name: 'Ungrouped event',
    starttime: `2021-08-26T15:00:00+02:00`,
    endtime: `2021-08-23T23:00:00+02:00`,
    startdate: '2021-08-26',
    enddate: '2021-08-26',
    profile: {
      name: 'project',
      id: '12-1626964156'
    },
    status: {
      name: 'Planned',
      id: '32-1626964157'
    },
    parentgroup: undefined,
    group: undefined,
    locations: [
      {
        name: 'Theaterzaal',
        id: '182-1626964157'
      }
    ],
    defaultschedulestarttime: null,
    defaultscheduleendtime: null,
    defaultschedulestart: `2021-08-26T15:00:00+02:00`,
    defaultscheduleend: null
  }
];

export const weekEventsDayOrderedByEventGroup5 = [
  {
    id: '7',
    name: 'Lunch',
    starttime: `2021-08-27T11:30:00+02:00`,
    endtime: `2021-08-27T13:30:00+02:00`,
    startdate: '2021-08-27',
    enddate: '2021-08-27',
    profile: {
      name: 'misc',
      id: '390-1626964157'
    },
    status: {
      name: 'Option',
      id: '30-1626964157'
    },
    group: {
      id: '576-1649059444',
      name: 'Lunches'
    },
    locations: [
      {
        name: 'Majolica',
        id: '202-1626964157'
      }
    ],
    defaultschedulestarttime: '11:30',
    defaultscheduleendtime: null,
    defaultschedulestart: `2021-08-27T11:30:00+02:00`,
    defaultscheduleend: null
  },

  {
    id: '8',
    name: 'Othello 4',
    starttime: `2021-08-27T15:00:00+02:00`,
    endtime: `2021-08-27T23:00:00+02:00`,
    startdate: '2021-08-27',
    enddate: '2021-08-27',
    profile: {
      name: 'project',
      id: '12-1626964156'
    },
    status: {
      name: 'Planned',
      id: '32-1626964157'
    },
    parentgroup: {
      id: '482-1649059444',
      name: 'Othello'
    },
    group: {
      id: '509-1649059444'
    },
    locations: [
      {
        name: 'Theaterzaal',
        id: '182-1626964157'
      }
    ],
    defaultschedulestarttime: null,
    defaultscheduleendtime: null,
    defaultschedulestart: `2021-08-27T15:00:00+02:00`,
    defaultscheduleend: null
  }
];

export const weekEventsDayOrderedByEventGroup6 = [];

export const weekEventsDayOrderedByEventGroup7 = [
  {
    id: '9',
    name: 'Lunch',
    starttime: `2021-08-29T11:30:00+02:00`,
    endtime: `2021-08-29T13:30:00+02:00`,
    startdate: '2021-08-29',
    enddate: '2021-08-29',
    profile: {
      name: 'misc',
      id: '390-1626964157'
    },
    status: {
      name: 'Option',
      id: '30-1626964157'
    },
    group: {
      id: '576-1649059444',
      name: 'Lunches'
    },
    parentgroup: {
      id: '576-1649059444',
      name: 'Lunches'
    },
    locations: [
      {
        name: 'Majolica',
        id: '202-1626964157'
      }
    ],
    defaultschedulestarttime: '11:30',
    defaultscheduleendtime: null,
    defaultschedulestart: `2021-08-29T11:30:00+02:00`,
    defaultscheduleend: null
  }
];

/*  _______________  */
/* |               | */
/* | EVENT GROUPS  | */
/* |_______________| */

export const testEventGroups = [
  {
    enddate: '2022-04-08',
    endtime: '2022-04-09T07:00:00+02:00',
    group: {
      url: 'http://localhost:8080/api/group/509-1649059444',
      id: '509-1649059444',
      name: 'Shakespeare'
    },
    id: '482-1649059444',
    name: 'Othello',
    parentgroup: {
      url: 'http://localhost:8080/api/group/509-1649059444',
      id: '509-1649059444',
      name: 'Shakespeare'
    },
    startdate: '2022-04-04',
    starttime: '2022-04-04T15:00:00+02:00',
    url: 'http://localhost:8080/api/group/482-1649059444'
  },
  {
    enddate: '2022-04-08',
    endtime: '2022-04-09T07:00:00+02:00',
    group: {
      url: 'http://localhost:8080/api/group/509-1649059444',
      id: '509-1649059444',
      name: 'Shakespeare'
    },
    id: '442-1649054342',
    name: 'Hamlet',
    parentgroup: {
      url: 'http://localhost:8080/api/group/509-1649059444',
      id: '509-1649059444',
      name: 'Shakespeare'
    },
    startdate: '2022-04-04',
    starttime: '2022-04-04T15:00:00+02:00',
    url: 'http://localhost:8080/api/group/442-1649054342'
  },
  {
    enddate: '2022-04-08',
    endtime: '2022-04-09T07:00:00+02:00',
    group: null,
    id: '509-1649059444',
    name: 'Shakespeare',
    parentgroup: null,
    startdate: '2022-04-04',
    starttime: '2022-04-04T15:00:00+02:00',
    url: 'http://localhost:8080/api/group/509-1649059444'
  },
  {
    enddate: '2022-07-06',
    endtime: '2022-07-06T13:30:00+02:00',
    group: null,
    id: '576-1649059444',
    name: 'Lunches',
    parentgroup: null,
    startdate: '2022-03-28',
    starttime: '2022-03-28T11:30:00+02:00',
    url: 'http://localhost:8080/api/group/576-1649059444'
  },
  {
    enddate: '2022-04-07',
    endtime: '2022-04-08T07:00:00+02:00',
    group: null,
    id: '421-1649059444',
    name: 'The Film Festival',
    parentgroup: null,
    startdate: '2022-03-28',
    starttime: '2022-03-28T07:00:00+02:00',
    url: 'http://localhost:8080/api/group/421-1649059444'
  },
  {
    enddate: '2022-04-06',
    endtime: '2022-04-07T07:00:00+02:00',
    group: null,
    id: '547-1649059444',
    name: 'The Room',
    parentgroup: null,
    startdate: '2022-04-05',
    starttime: '2022-04-06T07:00:00+02:00',
    url: 'http://localhost:8080/api/group/547-1649059444'
  },
  {
    enddate: '2022-06-06',
    endtime: '2022-06-07T07:00:00+02:00',
    group: null,
    id: '405129217-1651826407',
    name: 'Flanders Symphony Orchestra',
    parentgroup: null,
    startdate: '2022-04-05',
    starttime: '2022-04-05T07:00:00+02:00',
    url: 'http://localhost:8080/api/group/405129217-1651826407'
  },
  {
    enddate: '2022-06-06',
    endtime: '2022-06-07T07:00:00+02:00',
    group: {
      id: '405129217-1651826407',
      name: 'Flanders Symphony Orchestra',
      url: 'http://localhost:8080/api/group/405129217-1651826407'
    },
    id: '1239305217-1652121835',
    name: 'Bodega FSO',
    parentgroup: {
      id: '405129217-1651826407',
      name: 'Flanders Symphony Orchestra',
      url: 'http://localhost:8080/api/group/405129217-1651826407'
    },
    startdate: '2022-04-05',
    starttime: '2022-04-05T07:00:00+02:00',
    url: 'http://localhost:8080/api/group/1239305217-1652121835'
  },
  {
    enddate: '2022-06-06',
    endtime: '2022-06-07T07:00:00+02:00',
    group: {
      id: '405129217-1651826407',
      name: 'Flanders Symphony Orchestra',
      url: 'http://localhost:8080/api/group/405129217-1651826407'
    },
    id: '1225885953-1652121150',
    name: 'All FSO 2111007',
    parentgroup: {
      id: '405129217-1651826407',
      name: 'Flanders Symphony Orchestra',
      url: 'http://localhost:8080/api/group/405129217-1651826407'
    },
    startdate: '2022-04-05',
    starttime: '2022-04-05T07:00:00+02:00',
    url: 'http://localhost:8080/api/group/1225885953-1652121150'
  },
  {
    enddate: '2022-06-06',
    endtime: '2022-06-07T07:00:00+02:00',
    group: {
      id: '405129217-1651826407',
      name: 'Flanders Symphony Orchestra',
      url: 'http://localhost:8080/api/group/405129217-1651826407'
    },
    id: '405126657-1651826407',
    name: 'Loges FSO 211007',
    parentgroup: {
      id: '405129217-1651826407',
      name: 'Flanders Symphony Orchestra',
      url: 'http://localhost:8080/api/group/405129217-1651826407'
    },
    startdate: '2022-04-05',
    starttime: '2022-04-05T07:00:00+02:00',
    url: 'http://localhost:8080/api/group/405126657-1651826407'
  },
  {
    enddate: '2022-04-08',
    endtime: '2022-04-09T07:00:00+02:00',
    group: null,
    id: '509-1649059445',
    name: '',
    parentgroup: null,
    startdate: '2022-04-04',
    starttime: '2022-04-04T15:00:00+02:00',
    url: 'http://localhost:8080/api/group/509-1649059445'
  },
  {
    enddate: '2022-04-08',
    endtime: '2022-04-09T07:00:00+02:00',
    group: null,
    id: '509-1649059446',
    name: 'Events group with a long title that should be truncated',
    parentgroup: null,
    startdate: '2022-04-04',
    starttime: '2022-04-04T15:00:00+02:00',
    url: 'http://localhost:8080/api/group/509-1649059446'
  }
];
